import { _billingUrls } from '@custom/Utils/constants/apiUrls';
import { createAsyncThunk } from '@reduxjs/toolkit';

const deletePackage = createAsyncThunk('deletePackage', async (data: any) => {
  const token = sessionStorage.getItem('token') || localStorage.getItem('token');
  const { id } = data;

  try {
    const url = `${_billingUrls.delete}/${id}`;

    let response = await fetch(url, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    return await response.json();
  } catch (error) {
    return error;
  }
});

export default deletePackage;
